module.exports = __webpack_public_path__ + "img/file-upload-address.54bd5e8e.svg";